<template>
  <el-dialog
    top="10vh"
    class="edit-dialog"
    :title="row.id ? '编辑' : '新建'"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="close"
    :visible.sync="dialogVisible"
  >
    <div>
      <el-form ref="form" :rules="rules" :model="form" label-width="120px" size="small">
        <el-form-item label="账号:" prop="account">
          <el-input
            :disabled="!!row.id"
            style="width: 340px;"
            placeholder="账号"
            v-model.trim="form.account"
            :maxlength="40"
          />
        </el-form-item>
        <el-form-item label="密码:" prop="password" v-if="!row.id">
          <el-input
            style="width: 340px;"
            placeholder="密码"
            v-model.trim="form.password"
            :maxlength="16"
          />
        </el-form-item>
        <el-form-item label="真实姓名:" prop="name">
          <el-input
            style="width: 340px;"
            placeholder="真实姓名"
            v-model.trim="form.name"
            :maxlength="40"
          />
        </el-form-item>
        <el-form-item label="手机号:" prop="phone">
          <el-input
            style="width: 340px;"
            placeholder="手机号"
            v-model.trim="form.phone"
            :maxlength="11"
          />
        </el-form-item>
        <el-form-item label="邮箱:">
          <el-input style="width: 340px;" placeholder="邮箱" v-model.trim="form.email" />
        </el-form-item>
        <el-form-item label="启用状态:" prop="state">
          <el-radio-group v-model="form.state">
            <el-radio label="Y">启用</el-radio>
            <el-radio label="N">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="edit-footer">
      <el-button size="small" @click="close">取消</el-button>
      <el-button type="primary" size="small" @click="save">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: Object
  },
  data() {
    return {
      dialogVisible: this.visible,
      loading: false,
      form: {
        state: 'Y'
      },
      rules: {
        account: [
          {
            required: true,
            message: '请填写账号',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[0-9a-zA-Z\u4e00-\u9fa5]+$/
              if (!reg.test(value)) {
                callback(new Error('账号由中英文字符和数字组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        name: [
          {
            required: true,
            message: '请填写真实姓名',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[a-zA-Z\u4e00-\u9fa5]+$/
              if (!reg.test(value)) {
                callback(new Error('真实姓名由中英文字符组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        phone: [
          {
            required: true,
            message: '请填写手机号',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^1[3456789]\d{9}$/
              if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        password: [
          {
            required: true,
            message: '请填写密码',
            trigger: ['blur', 'change']
          },
          {
            validator: (rule, value, callback) => {
              const reg = /^[\x21-\x7E]+$/
              if (!reg.test(value) || value.length < 6) {
                callback(new Error('密码由6~16位英文字符、数字和特殊符号组成'))
              } else {
                callback()
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        state: [
          {
            required: true,
            message: '请选择启用状态',
            trigger: 'change'
          }
        ]
      }
    }
  },
  mounted() {
    if (this.row.id) {
      this.queryDetail(this.row.id)
    }
  },
  methods: {
    queryDetail(id) {
      let params = {
        id: id
      }
      this.$ajax.get(this.$api.system.user_detail, params).then((res) => {
        this.form = res.data
      })
    },
    close() {
      this.$emit('update:visible', false)
    },
    checkForm() {
      let pass
      this.$refs.form.validate((valid) => {
        pass = valid
      })
      return pass
    },
    save() {
      if (this.checkForm()) {
        if (this.form.email) {
          const rePass = new RegExp(
            '^([a-zA-Z0-9]+[_|\\_|\\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\\_|\\.]?)*[a-zA-Z0-9]+\\.[a-zA-Z]{2,3}$',
            ''
          )
          const isPass = rePass.test(this.form.email)
          if (!isPass) {
            this.$message.error('请输入正确的邮箱')
            return false
          }
        }
        let params = {
          ...this.form
        }

        let api = this.row.id ? this.$api.system.user_update : this.$api.system.user_add
        this.$ajax.post(api, params).then(() => {
          this.$message.success(`${this.row.id ? '修改成功' : '新建成功'}`)
          this.close()
          this.$emit('refresh')
        })
      }
    }
  }
}
</script>
<style lang="less"></style>
